import UserModal from 'components/UserModal/container';

export default UserModal;
